import { useContext } from "react";
import {
  FirmaFiltersContext,
  FirmaFiltersEventContext,
} from "../../../../../context/FiltersContext";
import {
  FirmaFilterKeys,
  FirmaSelskabsformSetting,
  QueryFilter,
} from "../../../../../interfaces/filters";
import { AccordionFilterItem } from "../../../../accordion/Accordion";
import AppliedFilterItem from "../../../../filter/AppliedFilterItem";
import { KodeSelect } from "../../../../formcontrols/KodeSelect";
import {
  FirmaDtoFilterInput,
  VirksomhedsformId,
} from "../../../../../interfaces/schema";
import { f } from "../../../../../util/f";
// import DateFilter from "../../../../filter/date/DateFilter";
// import { DateFilterEvent } from "../../../../filter/date/types";
// import { defaultDateEvent } from "../../../../filter/date/dateFilterHelpers";

const filterKey: QueryFilter<FirmaFilterKeys>["filterKey"] = "virksomhedsform";

function enumHelper(enumString: string | undefined) {
  const found = Object.values(VirksomhedsformId).find((item) => {
    const casedEnum = item.replaceAll("_", "").toLowerCase();
    const casedEnumString = enumString?.toLowerCase();
    return casedEnum === casedEnumString;
  });

  return found as VirksomhedsformId;
}

export default function FirmaSelskabsformFilter() {
  // query filter context
  const filters = useContext(FirmaFiltersContext);
  const updateFilters = useContext(FirmaFiltersEventContext);

  // find the filter settings
  const settings: FirmaSelskabsformSetting = filters.find(
    (f) => f.filterKey === filterKey,
  )?.settings;

  // state
  // const [latestDateEvent, setLatestDateEvent] =
  //   useState<DateFilterEvent>(defaultDateEvent);

  // stuff
  // const isDateDisabled = Boolean(!settings?.activeFilters?.length);

  // handlers
  function updateFilterHandler(
    selectedItem: KodeListe | null,
    // dateFilterEvent?: DateFilterEvent
  ) {
    // get active list if any otherwise initialise an empty array
    const activeFilters = settings?.activeFilters || [];

    // add selected item if it does not exist in active list
    if (
      selectedItem &&
      !activeFilters.some((s) => s.id === enumHelper(selectedItem?.id))
    ) {
      activeFilters.push({
        id: enumHelper(selectedItem.id),
        name: selectedItem.navn,
      });
    }

    // check for valid date event otherwise assign latest date event
    // if (!dateFilterEvent) {
    //   dateFilterEvent = latestDateEvent;
    // } else {
    //   setLatestDateEvent(dateFilterEvent);
    // }

    const filters: FirmaDtoFilterInput[] = activeFilters.map((set) => {
      return {
        and: [
          {
            virksomhedsform: {
              in: [set.id],
            },
          },
          // {
          //   periode: dateFilterEvent?.filter,
          // },
        ],
      };
    });

    // build the filter string
    const filterString = f<FirmaDtoFilterInput>()
      .addFilter("or", filters)
      .build();

    const updatedSettings: FirmaSelskabsformSetting = {
      activeFilters: activeFilters,
      // dateFilterSettings: dateFilterEvent.settings,
    };

    const queryFilter: QueryFilter<FirmaFilterKeys, FirmaSelskabsformSetting> =
      {
        filter: filterString,
        filterKey: filterKey,
        settings: updatedSettings,
        parentFilter: "and",
      };

    updateFilters({
      event: "update",
      queryFilter: queryFilter,
    });
  }

  function removeFilterHandler(
    id: FirmaSelskabsformSetting["activeFilters"][number]["id"],
  ) {
    const updatedFilters =
      settings?.activeFilters?.filter((set) => {
        return id !== set.id;
      }) || [];

    const filters: FirmaDtoFilterInput[] = updatedFilters.map((set) => {
      return {
        and: [
          {
            virksomhedsform: {
              in: [set.id],
            },
          },
          // {
          //   periode: latestDateEvent?.filter,
          // },
        ],
      };
    });

    // build the filter string
    const filterString = f<FirmaDtoFilterInput>()
      .addFilter("or", filters)
      .build();

    const updatedSettings: FirmaSelskabsformSetting = {
      activeFilters: updatedFilters,
      // dateFilterSettings: latestDateEvent.settings,
    };

    const update = updatedSettings?.activeFilters?.length > 0;

    if (update) {
      updateFilters({
        event: "update",
        queryFilter: {
          filterKey: filterKey,
          filter: filterString,
          settings: updatedSettings,
        },
      });
    } else {
      updateFilters({
        event: "delete",
        queryFilter: {
          filterKey: filterKey,
        },
      });
    }
  }

  return (
    <AccordionFilterItem
      title="Virksomhedsform"
      value="virksomhedsform"
      isActive={filters.some((f) => f.filterKey === filterKey)}
    >
      {settings && (
        <div className="c-applied-filter-group">
          {settings.activeFilters.map((filter) => (
            <AppliedFilterItem
              key={filter.id}
              label={filter.name}
              removeFilterHandler={() => removeFilterHandler(filter.id)}
            />
          ))}
        </div>
      )}

      <KodeSelect
        clearAfterSelection
        kodeListeType="VirksomhedsformKode"
        placeholder="Vælg virksomhedsform ..."
        onChange={(item) => {
          updateFilterHandler(item);
        }}
      />
      {/* <div className="mt-3">
        <DateFilter
          handleChange={(dateFilterEvent) => {
            updateFilterHandler(null, dateFilterEvent);
          }}
          settings={settings?.dateFilterSettings}
          disabled={isDateDisabled}
        />
      </div> */}
    </AccordionFilterItem>
  );
}
